import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from 'react-i18next';

const OutsourcingProvider2 = props => (
    <section id="outsourcing-provider-section2" className="blue-bg my pt-5">
        <Container>
            <p className='mb-5'>
                <Trans i18nKey="services:outsourcingProvider:section-1.txt"
                    components={{
                        br: <br />,
                        outsourcingPilar: <a rel="noreferrer" target='_blank' href={props.t('routes:outsourcing_pilar.path')} className="link" />
                    }}
                />
            </p>
            <div className="title-triangle top-md fw-600"></div>
            <h2 className="h4 black fw-600 mb-5">{props.t('services:outsourcingProvider:section-2.title')}</h2>
            {[1, 2].map(item => (
                <div key={item} className={item < 2 ? 'mb-5' : ''}>
                    <div className='d-flex align-items-center mb-4'>
                        <div className='arrow-container'>
                            <div className='arrow'>
                                <FontAwesomeIcon icon={['fas', 'arrow-right']} />
                            </div>
                        </div>
                        <h3 className='h5 fw-600 m-0'>{props.t('services:outsourcingProvider:section-2.' + item + '.title')}</h3>
                    </div>
                    <p className={item < 2 ? '' : 'm-0'}><Trans i18nKey={'services:outsourcingProvider:section-2.' + item + '.text'} components={{ br: <br /> }} /></p>
                </div>
            ))}
        </Container>
    </section>
);

export default OutsourcingProvider2;
